import Pillar from "../Pillar";

export default class Open extends Pillar {
	public static code = "threed_pillar_open";
}
